import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { NewWidgetFilterSettingsDialogBaseDirective } from '@fi-shared/fi-report-widget/new-report-widget-dialog/new-widget-filter-settings-dialog-base';
import { FiOnboardingReportHelperService } from '../../../services/fi-onboarding-report-helper.service';
import {
    IOnboardingReportWidget,
    IOnboardingReportWidgetFilter,
    IOnboardingReportAvailableItems,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import {
    FiOnboardingReportType,
    FiOnboardingReportWidgetType,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-enums';

@Component({
    selector: 'fi-onboarding-report-new-widget-data-filter-step',
    templateUrl: './fi-onboarding-report-new-widget-data-filter-step.component.html',
    styleUrls: ['./fi-onboarding-report-new-widget-data-filter-step.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-report-new-widget-data-filter-step' },
    standalone: false,
})
export class FiOnboardingReportNewWidgetDataFilterStepComponent extends NewWidgetFilterSettingsDialogBaseDirective<
    IOnboardingReportWidgetFilter,
    FiOnboardingReportType,
    IOnboardingReportWidget
> {
    private readonly fiOnboardingReportHelperService = inject(FiOnboardingReportHelperService);
    public availableItems = input.required<IOnboardingReportAvailableItems>();
    protected widgetName = computed(
        () => this.fiOnboardingReportHelperService.defaultWidgetNames[this.reportWidget().ReportType],
    );
    protected reportWidgetType = computed(() =>
        this.fiOnboardingReportHelperService.getReportWidgetTypeForDetails(this.reportWidget()),
    );
}
